'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const DayInMilliseconds=timespan.fromDays(1).totalMilliseconds();let
AddDoNotDisturbScheduleModalController=(_dec=



























HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(AddDoNotDisturbScheduleModalController,_BaseController);_createClass(AddDoNotDisturbScheduleModalController,null,[{key:'$inject',get:function(){return['$modalInstance','socketService','$scope','$timeout','uiCommandFactory','onScheduleAdded','timeZoneService','notificationService','uncaughtErrorHandler']}}]);function AddDoNotDisturbScheduleModalController($modalInstance,socketService,$scope,$timeout,uiCommandFactory,onScheduleAdded,timeZoneService,notificationService,uncaughtErrorHandler){_classCallCheck(this,AddDoNotDisturbScheduleModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._socketService=socketService;_this._$modalInstance=$modalInstance;_this._onScheduleAdded=onScheduleAdded;_this._$timeout=$timeout;_this._$scope=$scope;_this._addScheduleCommand=uiCommandFactory.makeForModal($modalInstance,_this._addSchedule.bind(_this));_this._daysOfWeek=moment.weekdays().map(function(day){return{day:day.substr(0,3)}});_this._selectedDaysOfWeek=[];_this._timeZone=timeZoneService.localTimeZone;_this._timeZoneService=timeZoneService;_this._notificationService=notificationService;_this._isPaused=!1;_this.isAllDay=!0;$scope.$watch('controller.selectedDaysOfWeek',function(){_this._resetSubmissionErrors()});return _this}AddDoNotDisturbScheduleModalController.prototype.
_addSchedule=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
this._resetSubmissionErrors();

if(this._formIsInvalid()){
return ModalSubmissionResult.KeepOpen;
}

let addScheduleRequestJSON={
startTimeOfDay:this.isAllDay?0:this._startTimeMsSinceMidnight,
endTimeOfDay:this.isAllDay?0:this._endTimeMsSinceMidnight,
daysOfWeek:this._daysOfWeek.map(function(day){return _.includes(_this2._selectedDaysOfWeek,day)}),
timeZone:this._timeZone,
isPaused:this._isPaused};


let addResult=yield this._socketService.sendAndWaitForResponse('AddDoNotDisturbSchedule',addScheduleRequestJSON);



yield this._onScheduleAdded(addResult);

return ModalSubmissionResult.Close();
});function _addSchedule(){return ref.apply(this,arguments)}return _addSchedule}();AddDoNotDisturbScheduleModalController.prototype.

_formIsInvalid=function _formIsInvalid(){var _this3=this;
let hasError=!1;

if(this._selectedDaysOfWeek.length===0){
this._$timeout(function(){return _this3.showSelectedDaysError=!0});
hasError=!0;
}

if(!this.isAllDay){
if(this.form['start-time'].$invalid||this.form['end-time'].$invalid){
hasError=!0;
}


if(this._startTimeMsSinceMidnight<0||this.startTimeMsSinceMidnight>DayInMilliseconds){
hasError=!0;
}
if(this._endTimeMsSinceMidnight<0||this.endTimeMsSinceMidnight>DayInMilliseconds){
hasError=!0;
}
}

return hasError;
};AddDoNotDisturbScheduleModalController.prototype.

dayOfWeekFormatter=function dayOfWeekFormatter(value){
return value.day;
};AddDoNotDisturbScheduleModalController.prototype.

onCancel=function onCancel(){
this._$modalInstance.dismiss();
};AddDoNotDisturbScheduleModalController.prototype.

_resetSubmissionErrors=function _resetSubmissionErrors(){var _this4=this;
this._$timeout(function(){return _this4.showSelectedDaysError=!1});
};_createClass(AddDoNotDisturbScheduleModalController,[{key:'addScheduleCommand',get:function()

{
return this._addScheduleCommand;
}},{key:'USIanaTimeZones',get:function()

{
return this._timeZoneService.USIanaTimeZones;
}},{key:'form',get:function()

{
return this._form;
},set:function(

form){
this._form=form;
}},{key:'startTimeMsSinceMidnight',get:function()

{
return this._startTimeMsSinceMidnight;
},set:function(

startTimeMsSinceMidnight){
this._startTimeMsSinceMidnight=startTimeMsSinceMidnight;
}},{key:'endTimeMsSinceMidnight',get:function()

{
return this._endTimeMsSinceMidnight;
},set:function(

endTimeMsSinceMidnight){
this._endTimeMsSinceMidnight=endTimeMsSinceMidnight;
}},{key:'selectedDaysOfWeek',get:function()

{
return this._selectedDaysOfWeek;
},set:function(

selectedDaysOfWeek){
this._selectedDaysOfWeek=selectedDaysOfWeek;
}},{key:'daysOfWeek',get:function()

{
return this._daysOfWeek;
},set:function(

daysOfWeek){
this._daysOfWeek=daysOfWeek;
}},{key:'timeZone',get:function()

{
return this._timeZone;
},set:function(

timeZone){
this._timeZone=timeZone;
}}]);return AddDoNotDisturbScheduleModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_addSchedule',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_addSchedule'),_class.prototype)),_class));


module.exports=AddDoNotDisturbScheduleModalController;
//# sourceMappingURL=addDoNotDisturbScheduleModalController.js.map
